import React from 'react';
import { Navigate } from 'react-router';
import { Link } from 'react-router-dom';
import Base from './Base';
import { ThemeContext } from './ThemeContext'
export class NavMenu extends Base {
    constructor(props) {
        super(props);
        this.state = {
            openMenu: '',
            data: null,
            loading: true,
            menuOpen: 1
        }
    }




    componentDidMount() {
        this.httpPost("api/v1/common/get")
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }



    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() : this.renderForm();

        return contents;
    }
    toggleMaiMenu() {
        if (this.state.menuOpen == 1) {
            this.setState({ menuOpen: 0 });
        } else {
            this.setState({ menuOpen: 1 });
        }
    }

    toggleMenu(menu) {
        if (this.state.openMenu == menu) this.setState({ openMenu: '' });
        else this.setState({ openMenu: menu });
    }


    static contextType = ThemeContext;
    renderForm() {

        const { dayNightTheme, seasonTheme  } = this.context;

        return <div className={`nk-sidebar nk-sidebar-fixed ${dayNightTheme} ${seasonTheme} ${this.state.menuOpen == 1 ? "" : "is-compact"}`} id="sideBarMenu" data-content="sidebarMenu">

            <div className="nk-sidebar-element nk-sidebar-head">
                <div className="nk-menu-trigger" onClick={e => this.toggleMaiMenu()}>
                    {this.state.menuOpen === 1 ? (
                        <a className="nk-nav-toggle nk-quick-nav-icon" data-target="sidebarMenu">
                            <em className="icon ni ni-menu"></em>
                        </a>
                    ) : (
                        <a className="nk-nav-toggle nk-quick-nav-icon" data-target="sidebarMenu">
                                <em className="icon ni ni-arrow-right"></em>
                        </a>
                    )}
                </div>


                <div className="nk-sidebar-brand">
                </div>
            </div>
            <div className="nk-sidebar-element nk-sidebar-body">
                <div className="nk-sidebar-content">
                    <div className="nk-sidebar-menu" data-simplebar>
                        <ul className="nk-menu">
                            <li className="nk-menu-item text-white">
                                <Link to="/" className="nk-menu-link">
                                    <span className="nk-menu-icon "><em className="icon ni ni-home"></em></span>
                                    <span className="nk-menu-text ">داشبورد</span>
                                </Link>
                            </li>
                            {this.state.data.global.user.role === 1 && <li className={"nk-menu-item has-sub " + (this.state.openMenu == "manager" ? "active" : "")} >
                                <a className="hand nk-menu-link nk-menu-toggle" onClick={e => this.toggleMenu('manager')} >
                                    <span className="nk-menu-icon "><em className="icon ni ni-users-fill"></em></span>
                                    <span className="nk-menu-text ">مدیریتی</span>
                                </a>
                                <ul className="nk-menu-sub" >
                                    <li className="nk-menu-item">
                                        <Link to="/users/" className="nk-menu-link">
                                            <span className="nk-menu-icon "><em className="icon ni ni-users"></em></span>
                                            <span className="nk-menu-text ">کاربران</span>
                                        </Link>
                                    </li>
                                    <li className="nk-menu-item">
                                        <Link to="/units/" className="nk-menu-link">
                                            <span className="nk-menu-icon "><em className="icon ni ni-coins"></em></span>
                                            <span className="nk-menu-text ">واحدهای اندازه گیری</span>
                                        </Link>
                                    </li>
                                    <li className="nk-menu-item">
                                        <Link to="/plans/" className="nk-menu-link">
                                            <span className="nk-menu-icon "><em className="icon ni ni-box"></em></span>
                                            <span className="nk-menu-text ">پلنها</span>
                                        </Link>
                                    </li>
                                    <li className="nk-menu-item">
                                        <Link to="/transactions/" className="nk-menu-link">
                                            <span className="nk-menu-icon "><em className="icon ni ni-coins"></em></span>
                                            <span className="nk-menu-text ">پرداختها</span>
                                        </Link>
                                    </li>
                                </ul>
                            </li>}

                            <li className={"nk-menu-item has-sub " + (this.state.openMenu == "base" ? "active" : "")}>
                                <a className="hand nk-menu-link nk-menu-toggle" onClick={e => this.toggleMenu('base')}>
                                    <span className="nk-menu-icon "><em className="icon ni ni-setting"></em></span>
                                    <span className="nk-menu-text ">اطلاعات پایه</span>
                                </a>
                                <ul className="nk-menu-sub">
                                    <li className="nk-menu-item">
                                        <Link to="/companies/" className="nk-menu-link">
                                            <span className="nk-menu-icon "><em className="icon ni ni-building"></em></span>
                                            <span className="nk-menu-text ">کسب و کار های من</span>
                                        </Link>
                                    </li>
                                    <li className="nk-menu-item">
                                        <Link to="/persons/" className="nk-menu-link">
                                            <span className="nk-menu-icon "><em className="icon ni ni-users"></em></span>
                                            <span className="nk-menu-text ">طرف حسابها</span>
                                        </Link>
                                    </li>
                                    <li className="nk-menu-item">
                                        <Link to="/tafsils/" className="nk-menu-link">
                                            <span className="nk-menu-icon "><em className="icon ni ni-users"></em></span>
                                            <span className="nk-menu-text "> سایر تفصیلی</span>
                                        </Link>
                                    </li>
                                    <li className="nk-menu-item">
                                        <Link to="/annuals/" className="nk-menu-link">
                                            <span className="nk-menu-icon "><em className="icon ni ni-view-col"></em></span>
                                            <span className="nk-menu-text ">سالهای مالی</span>
                                        </Link>
                                    </li>
                                    <li className="nk-menu-item">
                                        <Link to="/company/setting/" className="nk-menu-link">
                                            <span className="nk-menu-icon"><em className="icon ni ni-setting"></em></span>
                                            <span className="nk-menu-text ">تنظیمات</span>
                                        </Link>
                                    </li>
                                </ul>
                            </li>

                            <li className={"nk-menu-item has-sub " + (this.state.openMenu == "acc" ? "active" : "")}>
                                <a className="hand nk-menu-link nk-menu-toggle" onClick={e => this.toggleMenu('acc')}>
                                    <span className="nk-menu-icon"><em className="icon ni ni-coin"></em></span>
                                    <span className="nk-menu-text">حسابداری</span>
                                </a>
                                <ul className="nk-menu-sub">
                                    <li className="nk-menu-item">
                                        <Link to="/accounts/" className="nk-menu-link">
                                            <span className="nk-menu-icon "><em className="icon ni ni-layers"></em></span>
                                            <span className="nk-menu-text ">کدینگ حسابها</span>
                                        </Link>
                                    </li>
                                    <li className="nk-menu-item">
                                        <Link to="/documents/" className="nk-menu-link">
                                            <span className="nk-menu-icon"><em className="icon ni ni-file-docs"></em></span>
                                            <span className="nk-menu-text">اسناد حسابداری</span>
                                        </Link>
                                    </li>
                                    <li className="nk-menu-item">
                                        <Link to="/report/explore/" className="nk-menu-link">
                                            <span className="nk-menu-icon"><em className="icon ni ni-file-docs"></em></span>
                                            <span className="nk-menu-text">مرور حسابها</span>
                                        </Link>
                                    </li>
                                    <li className="nk-menu-item">
                                        <Link to="/closingdocument" className="nk-menu-link">
                                            <span className="nk-menu-icon"><em className="icon ni ni-file-docs"></em></span>
                                            <span className="nk-menu-text">عملیات پایان سال مالی</span>
                                        </Link>
                                    </li>
                                </ul>
                            </li>

                            <li className={"nk-menu-item has-sub " + (this.state.openMenu == "customers" ? "active" : "")}>
                                <a className="hand nk-menu-link nk-menu-toggle" onClick={e => this.toggleMenu('customers')}>
                                    <span className="nk-menu-icon"><em className="icon ni ni-cart-fill"></em></span>
                                    <span className="nk-menu-text">مشتریان و فروش</span>
                                </a>
                                <ul className="nk-menu-sub">
                                    <li className="nk-menu-item">
                                        <Link to="/invoices/sale/" className="nk-menu-link">
                                            <span className="nk-menu-icon"><em className="icon ni ni-file-docs"></em></span>
                                            <span className="nk-menu-text">صورتحساب های فروش</span>
                                        </Link>
                                    </li>
                                </ul>
                            </li>

                            <li className={"nk-menu-item has-sub " + (this.state.openMenu == "PayRec" ? "active" : "")}>
                                <a className="hand nk-menu-link nk-menu-toggle" onClick={e => this.toggleMenu('PayRec')}>
                                    <span className="nk-menu-icon"><em className="icon ni ni-cart-fill"></em></span>
                                    <span className="nk-menu-text">دریافت و پرداخت</span>
                                </a>
                                <ul className="nk-menu-sub">
                                    <li className="nk-menu-item ">
                                        <Link to="/banks" className="nk-menu-link disabled">
                                            <span className="nk-menu-icon"><em className="icon ni ni-file-docs"></em></span>
                                            <span className="nk-menu-text">تعریف بانک </span>
                                        </Link>
                                    </li>
                                    <li className="nk-menu-item ">
                                        <Link to="/operations" className="nk-menu-link disabled">
                                            <span className="nk-menu-icon"><em className="icon ni ni-file-docs"></em></span>
                                            <span className="nk-menu-text">تعریف عملیات </span>
                                        </Link>
                                    </li>
                                    <li className="nk-menu-item ">
                                        <Link to="/banktransactions" className="nk-menu-link disabled">
                                            <span className="nk-menu-icon"><em className="icon ni ni-file-docs"></em></span>
                                            <span className="nk-menu-text">لیست دریافت پرداخت  </span>
                                        </Link>
                                    </li>
                                </ul>
                            </li>



                            <li className={"nk-menu-item has-sub " + (this.state.openMenu == "warhouse" ? "active" : "")}>
                                <a className="hand nk-menu-link nk-menu-toggle" onClick={e => this.toggleMenu('warhouse')}>
                                    <span className="nk-menu-icon"><em className="icon ni ni-package-fill"></em></span>
                                    <span className="nk-menu-text">انبار داری</span>
                                </a>
                                <ul className="nk-menu-sub">
                                    <li className="nk-menu-item">
                                        <Link to="/warehouses/" className="nk-menu-link">
                                            <span className="nk-menu-icon "><em className="icon ni ni-layers"></em></span>
                                            <span className="nk-menu-text ">انبارها</span>
                                        </Link>
                                    </li>
                                    <li className="nk-menu-item">
                                        <Link to="/stuffs/" className="nk-menu-link">
                                            <span className="nk-menu-icon "><em className="icon ni ni-package-fill"></em></span>
                                            <span className="nk-menu-text ">کالاها/خدمات</span>
                                        </Link>
                                    </li>
                                    <li className="nk-menu-item">
                                        <Link to="/invoices/buy/" className="nk-menu-link">
                                            <span className="nk-menu-icon "><em className="icon ni ni-file-docs"></em></span>
                                            <span className="nk-menu-text ">صورتحساب های خرید</span>
                                        </Link>
                                    </li>
                                    <li className="nk-menu-item">
                                        <Link to="/remittances/out/" className="nk-menu-link">
                                            <span className="nk-menu-icon "><em className="icon ni ni-file-docs"></em></span>
                                            <span className="nk-menu-text ">حواله های انبار</span>
                                        </Link>
                                    </li>
                                    <li className="nk-menu-item">
                                        <Link to="/remittances/in/" className="nk-menu-link">
                                            <span className="nk-menu-icon "><em className="icon ni ni-file-docs"></em></span>
                                            <span className="nk-menu-text ">رسید های انبار</span>
                                        </Link>
                                    </li>
                                    <li className="nk-menu-item">
                                        <Link to="/report/explore/warehouse/" className="nk-menu-link">
                                            <span className="nk-menu-icon "><em className="icon ni ni-file-docs"></em></span>
                                            <span className="nk-menu-text ">مرور انبارها</span>
                                        </Link>
                                    </li>
                                    <li className="nk-menu-item">
                                        <Link to="/pricingremittance" className="nk-menu-link disabled">
                                            <span className="nk-menu-icon "><em className="icon ni ni-file-docs"></em></span>
                                            <span className="nk-menu-text ">قیمت گذاری اسناد انبار </span>
                                        </Link>
                                    </li>
                                </ul>
                            </li>

                            <li className={"nk-menu-item has-sub " + (this.state.openMenu == "Tax" ? "active" : "")}>
                                <a className="hand nk-menu-link nk-menu-toggle" onClick={e => this.toggleMenu('Tax')}>
                                    <span className="nk-menu-icon"><em className="icon ni ni-cart-fill"></em></span>
                                    <span className="nk-menu-text">مالیاتی</span>
                                </a>
                                <ul className="nk-menu-sub">
                                    <li className="nk-menu-item">
                                        <Link to="/taxconditions" className="nk-menu-link">
                                            <span className="nk-menu-icon"><em className="icon ni ni-file-docs"></em></span>
                                            <span className="nk-menu-text">ابلاغیات مالیاتی</span>
                                        </Link>
                                    </li>
                                </ul>
                            </li>

                            <li className={"nk-menu-item has-sub " + (this.state.openMenu == "tools" ? "active" : "")}>
                                <a className="hand nk-menu-link nk-menu-toggle" onClick={e => this.toggleMenu('tools')}>
                                    <span className="nk-menu-icon "><em className="icon ni ni-task-fill-c"></em></span>
                                    <span className="nk-menu-text ">ابزارها</span>
                                </a>
                                <ul className="nk-menu-sub">
                                    <li className="nk-menu-item">
                                        <Link to="/mytransactions/" className="nk-menu-link">
                                            <span className="nk-menu-icon "><em className="icon ni ni-coins"></em></span>
                                            <span className="nk-menu-text ">پرداختهای من</span>
                                        </Link>
                                    </li>
                                    <li className="nk-menu-item">
                                        <Link to="/inquiry/economiccode/" className="nk-menu-link">
                                            <span className="nk-menu-icon "><em className="icon ni ni-search"></em></span>
                                            <span className="nk-menu-text ">استعلام شناسه ملی</span>
                                        </Link>
                                    </li>
                                </ul>
                            </li>


                            <li className={"nk-menu-item has-sub " + (this.state.openMenu == "tools" ? "active" : "")}>
                                <Link to="/archive/" className="nk-menu-link">
                                    <span className="nk-menu-icon "><em className="icon ni ni-file-docs"></em></span>
                                    <span className="nk-menu-text ">آرشیو</span>
                                </Link>
                            </li>

                        </ul>
                    </div>
                </div>
            </div>
        </div>

    }
}
